const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_URL = `${API_URL}/api/admin`;

export const fetchUsers = async () => {
    const res = await fetch(`${ADMIN_URL}/users`, {
        method: 'GET',
        credentials: 'include'
    });
    if (!res.ok) {
        throw new Error('Failed to fetch users');
    }
    return res.json();
};

export const assignDemoPlan = async userId => {
    const res = await fetch(`${ADMIN_URL}/users/${userId}/assign-demo`, {
        method: 'POST',
        credentials: 'include'
    });
    if (!res.ok) {
        throw new Error('Failed to assign demo plan');
    }
    return res.json();
};

export const fetchAdminAnalytics = async (days = 30) => {
    const url = `${ADMIN_URL}/analytics?days=${encodeURIComponent(days)}`;
    const res = await fetch(url, {
        method: 'GET',
        credentials: 'include'
    });
    if (!res.ok) {
        throw new Error('Failed to fetch admin analytics');
    }
    return res.json();
};
